import { View } from '@react-pdf/renderer';

import Barcode from './Barcode';
import Image from './Image';
import RTLText from './RTLText';

const ExpandedDescription = ({ expandedDescription, styles, language }) => (
	<View
		style={{
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			alignItems: language === 'arabicValue' ? 'flex-end' : 'flex-start',
			justifyContent: 'flex-start',
			marginTop: 5,
			marginBottom: 5
		}}>
		<Image styles={{ maxWidth: 50, maxHeight: 50 }} source={expandedDescription.productImage} />
		<RTLText>{expandedDescription.name ?? '-'}</RTLText>
		<RTLText style={styles}>{expandedDescription.sku ?? '-'}</RTLText>
		<Barcode
			value={expandedDescription.barcode}
			options={{
				format: 'CODE128',
				height: 40,
				displayValue: false,
				flat: true,
				margin: 0
			}}
			barcodeStyles={{ ...styles, width: '100%' }}
			textStyles={styles}
		/>
	</View>
);

export default ExpandedDescription;
